import type React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useSidebar } from "./SidebarContext";
import type { IThemeState } from "../../types/theme";

interface CollapseButtonProps {
  theme: IThemeState;
}

export const CollapseButton: React.FC<CollapseButtonProps> = ({ theme }) => {
  const { isCollapsed, toggleCollapse } = useSidebar();

  return (
    <Tooltip title={isCollapsed ? "Expand" : "Collapse"} placement="right">
      <IconButton
        onClick={toggleCollapse}
        sx={{
          mx: "auto",
          my: 1,
          color: theme.neutral_colors?.[400],
          "&:hover": {
            backgroundColor: theme.neutral_colors?.[800],
            color: theme.primary_colors?.[400],
          },
        }}
      >
        {isCollapsed ? <ChevronRight /> : <ChevronLeft />}
      </IconButton>
    </Tooltip>
  );
};
